export default __webpack_public_path__ + "static/media/gusto7.d58948dc.jpg";